export const pageTitle = (title: string): string =>
  title ? `ZebraLearn • ${title}` : 'ZebraLearn';
